import React, { useEffect, useMemo, useState } from 'react';
import { CardContainer, UsersTable, UsersTableBody, UsersTableBodyColumn, UsersTableHead, UsersTableHeadColumn, UsersTableRow, H1 } from './style';
import Card from '../../../Components/Miscellaneous/Card';
import axios from 'axios';
import AuthService from '../../../AuthService';
import Zoom from 'react-medium-image-zoom'

import { BiPlus, BiPackage, BiBarChartAlt2 } from 'react-icons/bi';
import { PaginationButton, PaginationContainer } from '../../Categories/style';
import { Input, Loader } from '../../Login/style';
import Button from '../../../Components/Miscellaneous/Button';
import { toast } from 'react-toastify';
import CurrencyFormat from 'react-currency-format';

export default function Panel(){

    const [total, setTotal] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [navigateTo, setNavigateTo] = useState(null);
    const [modalOpened, setModalOpened] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData(1);
    }, []);

    const fetchData = (pageNumber) => {
        setLoading(true);
        axios.get(`https://api.rb.beeapp.es/admin/products?page=${pageNumber}`, {
            headers: {
                Authorization: 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => {
            const data = response.data;
            setProducts(data.results);
            setTotalPages(data.totalPages);
            setCurrentPage(pageNumber);
            setLoading(false);
        })
        .catch(error => {
            console.error(error);
            toast.error('Error al cargar productos');
            setLoading(false);
        });
    };

    const handlePageClick = (pageNumber) => {
        if (pageNumber === '...'){
            setModalOpened(true);
            return;
        }
        fetchData(pageNumber);
    };

    const deleteProduct = (id) => {
        const confirm = window.confirm('¿Estás seguro de que quieres eliminar este producto?');

        if (!confirm) {
            return;
        }
        axios.delete(`https://api.rb.beeapp.es/admin/product/${id}`, {
            headers: {
                'Authorization': `Bearer ${AuthService.getToken()}`,
            }
        })
        .then(response => {
            toast.success('Producto eliminado correctamente');
            fetchData(currentPage);
        })
        .catch(error => {
            console.error(error);
            toast.error('Error al eliminar producto');
        });
    }

    const Pagination = () => {
        const maxPagesToShow = 3;
        let startPage = Math.max(1, currentPage - maxPagesToShow);
        let endPage = Math.min(totalPages, currentPage + maxPagesToShow);

        if (startPage === 1) {
            endPage = Math.min(totalPages, startPage + maxPagesToShow * 2);
        } else if (endPage === totalPages) {
            startPage = Math.max(1, endPage - maxPagesToShow * 2);
        }

        const pages = [];
        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) {
                pages.push('...');
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pages.push('...');
            }
            pages.push(totalPages);
        }

        return (
            <div>
                {pages.map((page, index) => (
                    <PaginationButton
                        key={index}
                        onClick={() => handlePageClick(page)}
                        active={currentPage === page}
                        style={{ width: 'auto', minWidth: 40 }}
                    >
                        {page}
                    </PaginationButton>
                ))}
            </div>
        );
    };

    const ActionCard = ({ icon: Icon, title, onClick, color = '#028322' }) => (
        <div
            onClick={onClick}
            style={{
                backgroundColor: '#fff',
                border: `2px solid ${color}`,
                borderRadius: '12px',
                padding: '24px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '12px',
                minHeight: '140px',
                justifyContent: 'center'
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f0fdf4';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
        >
            <Icon style={{
                fontSize: '2.5rem',
                color: color
            }}/>
            <span style={{
                fontSize: '0.95rem',
                textAlign: 'center',
                color: '#374151',
                fontWeight: '500',
                fontFamily: 'Inter, sans-serif'
            }}>
                {title}
            </span>
        </div>
    );

    return (
        <>
        {loading && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0,0,0,0.3)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 100,
            }}>
                <div style={{
                    backgroundColor: '#fff',
                    padding: '32px',
                    borderRadius: '12px',
                    width: 'auto',
                    textAlign: 'center',
                }}>
                    <Loader />
                    <p style={{
                        marginTop: '16px',
                        color: '#6b7280',
                        fontSize: '14px',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Cargando productos...
                    </p>
                </div>
            </div>
        )}

        <div style={{
            padding: '24px',
            maxWidth: '1400px',
            margin: 'auto'
        }}>
            {/* Header Section */}
            <div style={{
                marginBottom: '32px'
            }}>
                <H1 style={{ marginBottom: '8px' }}>Panel de Productos</H1>
                <p style={{
                    color: '#6b7280',
                    fontSize: '14px',
                    margin: 0,
                    fontFamily: 'Inter, sans-serif'
                }}>
                    Gestiona tu catálogo de productos
                </p>
            </div>

            {/* Action Cards */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '20px',
                marginBottom: '32px'
            }}>
                <ActionCard
                    icon={BiPlus}
                    title="Crear Producto"
                    onClick={() => window.location.href = '/admin/product-create'}
                    color="#028322"
                />
                <ActionCard
                    icon={BiPackage}
                    title="Crear Catálogo"
                    onClick={() => window.location.href = '/admin/product-create'}
                    color="#0284c7"
                />
                <ActionCard
                    icon={BiBarChartAlt2}
                    title="Ver productos sin Stock"
                    onClick={() => window.location.href = '/admin/stock'}
                    color="#dc2626"
                />
            </div>

            {/* Products Table */}
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                overflow: 'hidden'
            }}>
                <UsersTable>
                    <UsersTableHead>
                        <UsersTableHeadColumn style={{ width: '80px' }}>Imagen</UsersTableHeadColumn>
                        <UsersTableHeadColumn>Producto</UsersTableHeadColumn>
                        <UsersTableHeadColumn style={{ width: '120px' }}>Stock</UsersTableHeadColumn>
                        <UsersTableHeadColumn style={{ width: '120px' }}>Precio</UsersTableHeadColumn>
                        <UsersTableHeadColumn style={{ width: '120px' }}>Acciones</UsersTableHeadColumn>
                    </UsersTableHead>
                    <UsersTableBody>
                        {products.length !== 0 ? products.map((product, index) => (
                            <UsersTableRow key={index}>
                                <UsersTableBodyColumn>
                                    <Zoom>
                                        <img
                                            src={product.images[0]}
                                            alt={product.name}
                                            style={{
                                                width: '50px',
                                                height: '50px',
                                                objectFit: 'contain',
                                                borderRadius: '8px',
                                                border: '1px solid #e5e7eb'
                                            }}
                                        />
                                    </Zoom>
                                </UsersTableBodyColumn>
                                <UsersTableBodyColumn
                                    onClick={() => window.location.href = '/admin/product-edit/' + product._id}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#028322',
                                        fontWeight: '500'
                                    }}
                                >
                                    {product.name}
                                </UsersTableBodyColumn>
                                <UsersTableBodyColumn>
                                    <span style={{
                                        padding: '4px 12px',
                                        borderRadius: '6px',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        backgroundColor: product.stock < 10 ? '#fee2e2' : '#dcfce7',
                                        color: product.stock < 10 ? '#dc2626' : '#16a34a'
                                    }}>
                                        {product.stock}
                                    </span>
                                </UsersTableBodyColumn>
                                <UsersTableBodyColumn>
                                    <CurrencyFormat
                                        value={product.price}
                                        displayType={'text'}
                                        thousandSeparator={false}
                                        suffix={'€'}
                                        decimalSeparator=','
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                    />
                                </UsersTableBodyColumn>
                                <UsersTableBodyColumn>
                                    <button
                                        onClick={() => window.location.href = '/admin/product-edit/' + product._id}
                                        style={{
                                            padding: '8px 16px',
                                            backgroundColor: '#028322',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            cursor: 'pointer',
                                            fontSize: '13px',
                                            fontWeight: '500',
                                            fontFamily: 'Inter, sans-serif',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => e.target.style.backgroundColor = '#026d1b'}
                                        onMouseLeave={(e) => e.target.style.backgroundColor = '#028322'}
                                    >
                                        Editar
                                    </button>
                                </UsersTableBodyColumn>
                            </UsersTableRow>
                        )) : (
                            <UsersTableRow>
                                <UsersTableBodyColumn colSpan="5" style={{
                                    textAlign: 'center',
                                    padding: '40px',
                                    color: '#9ca3af'
                                }}>
                                    No hay productos disponibles
                                </UsersTableBodyColumn>
                            </UsersTableRow>
                        )}
                    </UsersTableBody>
                </UsersTable>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <PaginationContainer style={{ marginTop: '24px' }}>
                    <Pagination />
                </PaginationContainer>
            )}

            {/* Modal */}
            {modalOpened && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 100
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '24px',
                        borderRadius: '12px',
                        width: '400px',
                        maxWidth: '90%'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <h3 style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#111827',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Ir a página
                            </h3>
                            <button
                                onClick={() => setModalOpened(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#9ca3af',
                                    padding: '0',
                                    lineHeight: '1'
                                }}
                            >
                                &times;
                            </button>
                        </div>

                        <Input
                            type="number"
                            placeholder={`Página (1-${totalPages})`}
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontFamily: 'Inter, sans-serif',
                                marginBottom: '16px'
                            }}
                            onChange={(e) => setNavigateTo(e.target.value)}
                            onFocus={(e) => e.target.style.borderColor = '#028322'}
                            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                        />

                        <Button
                            width="100%"
                            style={{
                                backgroundColor: '#028322',
                                padding: '12px',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '600'
                            }}
                            onClick={() => {
                                if (navigateTo > 0 && navigateTo <= totalPages) {
                                    handlePageClick(parseInt(navigateTo));
                                    setModalOpened(false);
                                } else {
                                    toast.error('Número de página inválido');
                                }
                            }}
                        >
                            Ir a la página
                        </Button>
                    </div>
                </div>
            )}
        </div>
        </>
    )
}
